import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { LayoutsModule } from './layouts/layouts.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { TableModule } from 'primeng/table';
import { SharedModule } from './shared/shared.module';
import { NgIdleModule } from '@ng-idle/core';
import { DatePipe } from '@angular/common';
import { DateWithoutTimezonePipe } from './core/pipes/date-without-timezone.pipe';
import { YesNoPipe } from './core/pipes/yes-no.pipe';
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LayoutsModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    TableModule,
    NgIdleModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers: [
    DatePipe,
    DateWithoutTimezonePipe,
    YesNoPipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
})
export class AppModule { }
